import {GridRowSelectionModel, GridSortModel} from '@mui/x-data-grid';
import {ChangeEvent, FC, useEffect} from 'react';
import {useRecoilState, useRecoilStateLoadable, useRecoilValue, useSetRecoilState} from 'recoil';
import {useEventBus} from '../../../../hooks/useEventBus';
import {
  assignableServiceRequestsState,
  serviceRequestsToAssignQueryTrigger,
  serviceRequestsToAssignSortQueryTrigger,
  serviceRequestsToAssignState,
} from '../../../../store/service-requests/atoms';
import {serviceRequestsToAssignQuery} from '../../../../store/service-requests/selectors';
import {Table} from '../../../Table';
import {columns} from './columns';
import {TableToolbar} from './TableToolbar';
import {map, toNumber} from 'lodash';
import {LoadableHelpers} from '../../../../shared/helpers/loadableHelpers';
import {SelectChangeEvent} from '@mui/material';

interface IServiceRequestsTable {
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangePage: (event: unknown, newPage: number) => void;
  page: number;
  size: number;
}

const ServiceRequestsTable: FC<IServiceRequestsTable> = ({handleChangePage, handleChangeRowsPerPage, page, size}) => {
  const [loadable, setServiceRequests] = useRecoilStateLoadable(serviceRequestsToAssignQuery);
  const {totalPages, totalElements, content: serviceRequests} = useRecoilValue(serviceRequestsToAssignState);
  const setAssignableServiceRequests = useSetRecoilState(assignableServiceRequestsState);
  const assignableServiceRequests = useRecoilValue(assignableServiceRequestsState);
  const triggerQuery = useSetRecoilState(serviceRequestsToAssignQueryTrigger);
  const [sort, setSort] = useRecoilState(serviceRequestsToAssignSortQueryTrigger);
  const bus = useEventBus();

  const handleSelect = (ids: GridRowSelectionModel) => {
    setAssignableServiceRequests((prev) => ({...prev, [page]: map(ids, toNumber)}));
  };

  const handlePageSizeChange = (e: SelectChangeEvent<number>) => {
    handleChangeRowsPerPage(e as ChangeEvent<HTMLInputElement>);
  };

  const handleSortModelChange = (model: GridSortModel) => {
    setSort([...model]);
  };

  useEffect(() => {
    LoadableHelpers.handle(loadable, {
      success: setServiceRequests,
      error: bus?.emit,
    });

    return () => {
      if (!LoadableHelpers.isLoading(loadable)) triggerQuery((v) => v + 1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadable.state]);

  return (
    <>
      <TableToolbar />
      <Table
        name="serviceRequestsAssign"
        loading={LoadableHelpers.isLoading(loadable)}
        rows={serviceRequests}
        columns={columns}
        sortModel={sort}
        pageSize={size}
        totalPages={totalPages}
        totalCount={totalElements}
        rowSelectionModel={assignableServiceRequests[page]}
        currentPage={page}
        startPageFromZero
        checkboxSelection
        onSortModelChange={handleSortModelChange}
        onPageSizeChange={handlePageSizeChange}
        onPaginationChange={handleChangePage}
        onRowSelectionModelChange={handleSelect}
      />
    </>
  );
};

export default ServiceRequestsTable;
